export default __webpack_public_path__ + "static/2.3.2/media/loginimage.41fb273e.svg";